import { Typography, Grid, Box } from '@material-ui/core';
import {
  createSelectField,
  createTextField,
  createNumberFormatField,
  createDateField,
  createAutocompleteAddressField,
  createRadioField,
} from '@roc/ui/componentBuilder';
import { observer } from 'mobx-react-lite';
import { borrowerStatesNames, borrowerStatesAbbreviation, borrowerEntityTypeOptions, createClosingConditionsLevelOptions } from '@roc/feature-utils';
import { useEffect } from 'react';
import { CreateClosingConditionStore } from 'libs/feature-documents/src/documents/stores/documentForms/closingCondition/createClosingConditionStore';

interface CreateClosingConditionsProps {
  store: CreateClosingConditionStore;
}

const CreateClosingConditions = observer((props: CreateClosingConditionsProps) => {
  const { store } = props;
  const fields = store.form.fields;
  return (
    <Grid container spacing={3} style={{
      width: '100%'
    }}>
      <Grid item xs={12}>
        {createSelectField({
          store,
          testId: 'level',
          fieldName: 'level',
          label: 'Closing Condition Level',
          options: createClosingConditionsLevelOptions,
          disabled: false,
        })}
      </Grid>
      <Grid item xs={12}>
        {createTextField({
          store,
          testId: 'description',
          fieldName: 'description',
          label: 'Closing Condition Description',
          multiline: true,
          minRows: 10,
          disabled: false,
        })}
      </Grid>
    </Grid>
  );
});

export default CreateClosingConditions;
